import { defineStore } from 'pinia'
import SyncKiovietService from "@/services/sync-kiotviet.service";
import ProductService from "@/services/product.service.js";
export const useSyncKiotviet = defineStore('syncKiotviet', {
    state: () => {
        return {
            data_partners: [],
            data_deliveries: [],
            datas: [],
            paginate: {},
            paginate_deliveries: {},
        }
    },
    persist: true,
    actions: {
        async connect(url, params) {
            try {
                const res = await SyncKiovietService.connect(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },
        async status(url, params) {
            try {
                const res = await SyncKiovietService.status(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },

        async getlistDataProduct(url, params) {
            try {
                const res = await SyncKiovietService.getlistDataProduct(url, params)
                this.datas = res.data.data;
                this.paginate = res.data.meta;
            } catch (e) {
                return null
            }
        },
        async syncProducts(url, params) {
            try {
                const res = await SyncKiovietService.syncProducts(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },

        async getlistDataPartner(url, params) {
            try {
                const res = await SyncKiovietService.getlistDataPartner(url, params)
                this.datas = res.data.data;
                this.paginate = res.data.meta;
            } catch (e) {
                return null
            }
        },
        async syncPartners(url, params) {
            try {
                const res = await SyncKiovietService.syncPartners(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },
        async getListPartnerSyncKiotvietConnected(url, params) {
            try {
                const res = await SyncKiovietService.getListPartnerSyncKiotvietConnected(url, params)
                this.data_partners = res.data.data;
            } catch (e) {
                return null
            }
        },

        async getlistDataDelivery(url, params) {
            try {
                const res = await SyncKiovietService.getlistDataDelivery(url, params)
                this.data_deliveries = res.data.data;
                this.paginate_deliveries = res.data.meta;
            } catch (e) {
                return null
            }
        },
        async syncDeliveries(url, params) {
            try {
                const res = await SyncKiovietService.syncDeliveries(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },

        async getlistDataDeliveryDetail(url, params) {
            try {
                const res = await SyncKiovietService.getlistDataDeliveryDetail(url, params)
                this.datas = res.data.data;
            } catch (e) {
                return null
            }
        },
    }
})
